export default __webpack_public_path__ + "static/react-f3e576ba08e6be927148e87ad9c79ac6.png";